import type { IAvatarImageProps } from './AvatarImage'

import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { MEDIA } from 'vars/index'

export const AvatarImageContainerSC = styled.div<
  Pick<IAvatarImageProps, 'width' | 'height' | 'selected' | 'corners' | 'hover'>
>`
  position: relative;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  border-radius: ${({ corners }) => `var(${corners})`};
  overflow: hidden;

  ${MEDIA.NO_TOUCH} {
    &:hover {
      cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};

      &:before {
        display: ${({ hover }) => (hover ? 'block' : 'none')};
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${({ selected }) =>
          selected ? 'none' : `var(${COLOR.SURFACE_OPACITY_DARK_40})`};
      }
    }
  }
`

export const AvatarSelectedSC = styled.div<Pick<IAvatarImageProps, 'corners'>>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(${COLOR.SURFACE_OPACITY_DARK_40});
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AvatarImageSC = styled.img<Pick<IAvatarImageProps, 'corners'>>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
